import { c as _c } from "react/compiler-runtime";
import { useRef } from 'react';
import StandaloneIframe from '@/app/[locale]/(worlds)/[roomId]/components/StandaloneIframe';
import WorldIframe from '@/app/[locale]/(worlds)/[roomId]/components/WorldIframe';
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
import { useIframeScrollLock } from '@/hooks/useIframeScrollLock';
import { useIframeTouchOutsideUnLock } from '@/hooks/useIframeTouchOutsideUnLock';
type IframeContentProps = {
  setScrollLock?: (isLocked: boolean) => void;
};
function IframeContent(t0) {
  const $ = _c(5);
  const {
    setScrollLock
  } = t0;
  const {
    roomData
  } = useCheckEnterRoomContext();
  const isStandalone = roomData.scene_type === "standalone";
  const isVideoWorld = roomData.scene_type === "blendvision" || !!roomData.vod_id;
  const effectiveScrollLock = isVideoWorld ? undefined : setScrollLock;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      enableFocus: true,
      enableHover: true
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    handlers
  } = useIframeScrollLock(t1, effectiveScrollLock);
  const iframeRef = useRef(null);
  useIframeTouchOutsideUnLock(iframeRef, effectiveScrollLock);
  let t2;
  if ($[1] !== handlers || $[2] !== isStandalone || $[3] !== isVideoWorld) {
    t2 = isStandalone || isVideoWorld ? <StandaloneIframe handlers={handlers} ref={iframeRef} isVideoWorld={isVideoWorld} /> : <WorldIframe handlers={handlers} ref={iframeRef} />;
    $[1] = handlers;
    $[2] = isStandalone;
    $[3] = isVideoWorld;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export default IframeContent;